import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { PresentationChartBarIcon } from '@heroicons/react/outline';
import { useTranslation } from 'react-i18next';
import { apiZedocGetProjectBundleToken } from '../../../../common/api/zedoc';
import IframeEmbed from '../../../../components/patients/IframeEmbed';
import BetaBadge from '../../../../components/BetaBadge';
import Dialog from '../../../../components/Dialog';
import { UI_SIZE__FULL } from '../../../../ui/schemata';

const ProjectBundle = ({ projectId }) => {
  const { t } = useTranslation();

  const [visible, setVisible] = useState(false);

  const handleOpen = () => setVisible(true);
  const handleClose = () => setVisible(false);

  return (
    <>
      <button
        data-testid="button-project-bundle"
        type="button"
        className="p-4 bg-surface border border-divider rounded-md cluster-4 items-center transition-colors hover:bg-primary-100"
        onClick={handleOpen}
      >
        <div className="bg-neutral-500 rounded-full w-10 h-10 p-2">
          <PresentationChartBarIcon />
        </div>
        <div className="stack-0 items-start">
          <div className="cluster-2 items-center">
            <span className="text-sm font-medium">{t('projectBundle')}</span>
            <BetaBadge />
          </div>
          <span className="text-sm text-secondary">
            {t('performanceInsights')}
          </span>
        </div>
      </button>
      <Dialog
        title={t('projectBundle')}
        size={UI_SIZE__FULL}
        onCancel={handleClose}
        visible={visible}
        onOk={handleClose}
        footer={null}
      >
        <IframeEmbed
          apiSpec={apiZedocGetProjectBundleToken}
          params={{ projectId }}
          title={t('projectBundle')}
          toolName="project bundle tool"
        />
      </Dialog>
    </>
  );
};

ProjectBundle.propTypes = {
  projectId: PropTypes.string.isRequired,
};

export default ProjectBundle;
